import { render, staticRenderFns } from "./Single-Quotation-Detail.vue?vue&type=template&id=c3a6fd40&scoped=true"
import script from "./Single-Quotation-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Quotation-Detail.vue?vue&type=script&lang=js"
import style0 from "./Single-Quotation-Detail.vue?vue&type=style&index=0&id=c3a6fd40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a6fd40",
  null
  
)

export default component.exports